@let agreement = $agreement();
@let agreementStats = $agreementStats();
@if (agreement) {
  <unity-page-container
    class="internal-agreement-view"
    contentHeader="Agreement: "
    [contentHeaderSecondary]="$contentHeaderSecondary()"
    [contentHeaderTertiary]="$contentHeaderTertiary()"
    [isLoading]="$resourceLoading()">
    <ng-container item-selector>
      <unity-agreement-selector-shared
        [isLoading]="$assignedAgreementsIsLoading()"
        [data]="$assignedAgreements()"
        [defaultItem]="agreement" />
    </ng-container>
    <ng-container notifications />

    <ng-container actions>
      <h5>Actions</h5>
      @for (action of $actions(); track action.actionName) {
        <unity-action-shared [action]="action" />
      }
      @if ($showActionCategoryLabels()) {
        <h5>Management Actions</h5>
      }
      @for (action of $managementActions(); track action.actionName) {
        <unity-action-shared [action]="action" />
      }
    </ng-container>

    <ng-container stats>
      @if (agreement.supports_clients) {
        <unity-card-item-count-summary-shared
          displayName="Active Clients"
          [itemCount]="agreementStats?.total_active_clients"
          [isLoading]="$statsLoading()" />
        <unity-card-budget-summary-shared [agreement]="agreementStats" [isLoading]="$statsLoading()" />
      }
      @if (agreement.supports_forms) {
        <unity-card-item-count-summary-shared
          displayName="Overdue Items"
          [itemCount]="$overdueFormCount()"
          [hasWarning]="false"
          [isLoading]="$statsLoading()" />
      }
      @if (agreement.supports_disbursements) {
        <unity-card-funds-disbursed-summary-shared [agreement]="agreementStats" [isLoading]="$statsLoading()" />
        <unity-card-remaining-award-summary-shared [agreement]="agreementStats" [isLoading]="$statsLoading()" />
      }
    </ng-container>

    @if ($isDraft() === true) {
      <unity-banner-alert-shared notifications icon="infoSolidIcon">
        This Agreement is in a 'Draft' state, visible only to AHFC users.
        <span *unityAuthorize="'Agreement:Update'">
          <unity-link-shared displayText="Edit this agreement" [variants]="['inline']" [link]="['/agreement', agreement.id]" /> to change
          its state.
        </span>
      </unity-banner-alert-shared>
    } @else if ($isDisabled() === true) {
      <unity-banner-alert-shared notifications icon="infoSolidIcon">
        This Agreement is in a 'Disabled' state, visible only to AHFC users.
        <span *unityAuthorize="'Agreement:Update'">
          <unity-link-shared displayText="Edit this agreement" [variants]="['inline']" [link]="['/agreement', agreement.id]" /> to change
          its state.
        </span>
      </unity-banner-alert-shared>
    }
  </unity-page-container>
}
